module.exports = __webpack_public_path__ + "img/hc-heatloss.802a27ce.png";